import axios from '../config/axios';
import { getApiUrl } from '../config/environment';
import type { PosturalPhoto, PosturalPhotoViewKey } from '../types/physiotherapyAssessment';
import { POSTURAL_PHOTO_VIEWS } from '../constants/posturalAssessmentSchema';

const viewLabel = (view: PosturalPhotoViewKey) =>
  POSTURAL_PHOTO_VIEWS.find((v) => v.key === view)?.label || view;

export async function uploadPosturalAssessmentPhoto(
  patientId: string,
  file: File,
  view: PosturalPhotoViewKey,
): Promise<PosturalPhoto> {
  const fd = new FormData();
  fd.append('file', file);
  const { data: uploadRes } = await axios.post(
    getApiUrl('/clinic/patient-images/upload'),
    fd,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  if (!uploadRes?.success || !uploadRes?.data?.file_url) {
    throw new Error(uploadRes?.error || 'Falha no upload da imagem');
  }

  let patientImageId: string | null = null;
  try {
    const { data: createRes } = await axios.post(getApiUrl('/clinic/patient-images'), {
      patient_id: patientId,
      title: `Avaliação postural — ${viewLabel(view)}`,
      description: 'Foto da avaliação postural fisioterapêutica',
      image_type: 'photo',
      file_url: uploadRes.data.file_url,
      file_name: uploadRes.data.file_name || file.name,
      file_type: uploadRes.data.file_type || file.type,
      file_size: uploadRes.data.file_size || file.size,
      capture_date: new Date().toISOString().split('T')[0],
      metadata: { source: 'postural_assessment', view },
    });
    if (createRes?.success && createRes?.data?.id) {
      patientImageId = createRes.data.id;
    }
  } catch {
    // Mantém a foto na avaliação mesmo se o registro na galeria falhar.
  }

  return {
    file_url: uploadRes.data.file_url,
    file_name: uploadRes.data.file_name || file.name,
    patient_image_id: patientImageId,
  };
}
